/**
 * Source data in https://docs.google.com/spreadsheets/d/1SjWadQqN-ZxPqW3hNMNHe1-LZA9EZN7jt8FCxbGaoKg/edit for now,
 * please make sure data here matches data in there every time something is changed
 */
export const reasonCategoryConfig: { [dc: string]: { [key: string]: { reasonDisplay: string, commentDraft: string } } } = {
    "REMOVAL": {
        "": { reasonDisplay: "(select)", commentDraft: "" },
        'terms_and_conditions_breach': { reasonDisplay: 'Breach of T&Cs', commentDraft: 'manual removal - breach of terms and conditions' },
        'chargeback': { reasonDisplay: 'Chargeback', commentDraft: 'manual removal - chargeback' },
        'gc_purchase_cancelled': { reasonDisplay: 'Cancelled GC Purchase', commentDraft: 'manual removal - cancelled gold coins purchase' },
        'internal_error_adjustment': { reasonDisplay: 'Internal Error Adjustment', commentDraft: 'manual removal - internal error adjustment' },
        'sc_expiration': { reasonDisplay: 'Sweeps Coins Expired', commentDraft: 'manual removal - sweeps coins expiration' },
    },
    "ADDITION": {
        "": { reasonDisplay: "(select)", commentDraft: "" },
        'amoe': { reasonDisplay: 'AMOE', commentDraft: 'manual addition - AMOE' },
        'account_management_goodwill': { reasonDisplay: 'Account Management - Goodwill', commentDraft: 'manual addition - one-off goodwill for account managed player' },
        'account_management_rewards': { reasonDisplay: 'Account Management - Rewards', commentDraft: 'manual addition - reward for account managed player' },
        'customer_service_goodwill': { reasonDisplay: 'Customer Service - Goodwill', commentDraft: 'manual addition - one-off good will for player' },
        'marketing_promotion': { reasonDisplay: 'Marketing Promotion', commentDraft: 'manual addition - marketing promotion' },
        'purchase_issue': { reasonDisplay: 'Purchase Issue', commentDraft: 'manual addition - purchase issue' },
        'redemption_issue': { reasonDisplay: 'Redemption Issue', commentDraft: 'manual addition - redemption issue' },
        'technical_issue': { reasonDisplay: 'Technical Issue - Add Coin Prizes', commentDraft: 'manual addition - technical issue' },
    },
}



// WEBPACK FOOTER //
// ./src/app/ui/dropdown-options.ts